var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdFicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.5,
    height: 13.5,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0V3.25C4 3.44891 4.07902 3.63968 4.21967 3.78033C4.36032 3.92098 4.55109 4 4.75 4H8V9C8 9.26522 7.89464 9.51957 7.70711 9.70711C7.51957 9.89464 7.26522 10 7 10H1C0.734784 10 0.48043 9.89464 0.292893 9.70711C0.105357 9.51957 0 9.26522 0 9V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4ZM3.5055 4.924C3.38581 5.68553 2.98756 6.37547 2.388 6.86C1.9445 7.218 2.35 7.9205 2.882 7.716C3.60141 7.43893 4.39809 7.43893 5.1175 7.716C5.6495 7.921 6.055 7.2185 5.6115 6.86C5.01193 6.37547 4.61369 5.68553 4.494 4.924C4.4055 4.361 3.594 4.3605 3.5055 4.924ZM4 6.1515L4.403 6.8485H3.598L4 6.1515ZM5 0.0215C5.18944 0.0616777 5.36314 0.155996 5.5 0.293L7.707 2.5C7.844 2.63686 7.93832 2.81056 7.9785 3H5V0.0215Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdFicon);
export default __webpack_public_path__ + "static/media/PDFicon.bfe5405c13eab0c64a40b14c8e0b0171.svg";
export { ForwardRef as ReactComponent };